export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/price.ba13b78e.svg","height":176,"width":175,"blurWidth":0,"blurHeight":0};